import { loadAndCacheImage } from "@cornerstonejs/core/loaders/imageLoader";
import { renderViewports } from "../pages/StudyViewer/helpers/CornerstoneViewportService";
import { annotation } from "@cornerstonejs/tools";
import { metaData } from "@cornerstonejs/core";
import { NONXRAYMODALITIES } from "../constants/Constants";



function worldToPixel(point, pixelSpacing = [1, 1]) {
  const [spacingX, spacingY] = pixelSpacing;
  const [xMm, yMm] = point;

  return [
    xMm / spacingX,
    yMm / spacingY,
  ];
}

  export const  loadDicomAndDrawRectangle = async (imageURL, annotations)=> {
    // 1. Load the image
    const image = await loadAndCacheImage(imageURL); // imageId = 'wadouri:http://...'
    const imagePlane = metaData.get("imagePlaneModule", image.imageId);
    const { width, height } = image;
    console.log("image height and width", height, width);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
 canvas.style.width = width + 'px';
  canvas.style.height = height + 'px';
    const ctx = canvas.getContext('2d');
    const imageData = ctx.createImageData(width, height);
    convertPixelDataToImage(image, imageData);

    // 4. Draw image and rectangle
    ctx.putImageData(imageData, 0, 0);
  annotations.forEach(({ data: { handles: { points } } }) => {
  if (points.length !== 4) return;

  // If points are already in image pixel space, use directly
   let xs = points.map(([x]) => x);
      let ys = points.map(([, y]) => y);
  if(imagePlane.pixelSpacing != null ){
    const imagePoints = points.map((worldPoint) =>
        worldToPixel(worldPoint, imagePlane.pixelSpacing)
    );
     xs = imagePoints.map(([x]) => Math.max(0, Math.min(width - 1, x)));
    ys = imagePoints.map(([, y]) => Math.max(0, Math.min(height - 1, y)));
    
  }


const x = Math.min(...xs);
const y = Math.min(...ys);
const rectWidth = Math.max(...xs) - x;
const rectHeight = Math.max(...ys) - y;


  if (rectWidth <= 0 || rectHeight <= 0) return;


ctx.fillStyle = 'rgba(255, 255, 255, 1.0)';
ctx.fillRect(x, y, rectWidth, rectHeight);

  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = 2;
  ctx.strokeRect(x, y, rectWidth, rectHeight);
});

    const base64Image = canvas.toDataURL('image/png');
    return base64Image.split(',')[1];
  }

  
    export const convertPixelDataToImage = (image, imageData)=>{
  
      const pixelData = image.getPixelData();
      const { width, height, windowCenter, windowWidth } = image;
      console.log("windowcenter:: ", windowCenter, "windowwidth::", windowWidth);
      const photometric = image.imageFrame.photometricInterpretation || 'MONOCHROME2';
      const samplesPerPixel = image.imageFrame.samplesPerPixel || 1;
  
      if (photometric === 'RGB' && samplesPerPixel === 3) {
        // RGB image
        for (let i = 0; i < width * height; i++) {
          const r = pixelData[i * 3 + 0];
          const g = pixelData[i * 3 + 1];
          const b = pixelData[i * 3 + 2];
  
          imageData.data[i * 4 + 0] = r;
          imageData.data[i * 4 + 1] = g;
          imageData.data[i * 4 + 2] = b;
          imageData.data[i * 4 + 3] = 255;
        }
      } else {
        // Grayscale image (MONOCHROME2)
        const center = windowCenter || 128;
        const ww = windowWidth || 256;
        const min = center - ww / 2;
        const max = center + ww / 2;
  
        for (let i = 0; i < width * height; i++) {
          const value = pixelData[i];
          const gray = Math.min(255, Math.max(0, ((value - min) / (max - min)) * 255));
  
          imageData.data[i * 4 + 0] = gray;
          imageData.data[i * 4 + 1] = gray;
          imageData.data[i * 4 + 2] = gray;
          imageData.data[i * 4 + 3] = 255;
        }
      }
      return imageData;
      
    }


   export const  removeMaskImageAnnotation = (maskImages)=>{
        let isRender = false;
        for(const key in maskImages){
            for(const annotationdata in maskImages[key].maskAnnotationData){
                isRender = true;
                 annotation.state.removeAnnotation(maskImages[key].maskAnnotationData[annotationdata].annotationUID);
            }
        }
        if(isRender)
            renderViewports();
    }

   export const isLLMAgentPresent = (modality, studyDescription) => {
    return true;
    // const LLM_RULES = [
    //   { modalities: NONXRAYMODALITIES, studyDescriptions: ["CHEST"] },
    //   { modalities: ["CT"], studyDescriptions: ["BRAIN"] },
    //    { modalities: ["MR"], studyDescriptions: ["SPINE"] },
    //   { modalities: ["CR", "DX", "RF"], studyDescriptions: ["UP_EXM", "LOW_EXM", "PELVIS", "Femur", "Humerus"] }

    // ];
    
    // if (!modality || !studyDescription) return false;
    // const normModality = modality.toUpperCase();
    // const normDesc = studyDescription.toUpperCase();

    // return LLM_RULES.some(rule =>
    // rule.modalities.some(m => normModality === m.toUpperCase()) &&
    // rule.studyDescriptions.some(desc => normDesc.includes(desc.toUpperCase())));
};
